// removed by extract-text-webpack-plugin
module.exports = {"root":"_3cdQy","inner":"_2bfK2","heading":"_8CA_Z","content":"_3nhkF"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/HeroSection/HeroSection.scss
// module id = 1307
// module chunks = 3